import { createSelector } from 'reselect'

const getCardsById = state => {
  return state['view-board'].cards
}

const createCardIdsSelector = (getBoardId) => createSelector(
  [getBoardId, getCardsById],
  (boardId, cardsById: any) => 
    Object.keys(cardsById).filter(key => cardsById[key].boardId === boardId)
)

export default createCardIdsSelector
